import { Component, OnInit } from '@angular/core';
import dayjs from 'dayjs';
import { NgClass } from '@angular/common';
import { CdkDragHandle } from '@angular/cdk/drag-drop';
import { FormsModule } from '@angular/forms';
import { BudgetLineItemComponent } from '../budget-line-item.component';
import { DropdownComponent } from '../../../../../../../framework/inputs/dropdown/dropdown.component';
import { InputCalendarComponent } from '../../../../../../../framework/inputs/input-calendar/input-calendar.component';
import { SpendCustomInputComponent } from '../../../../../../../framework/inputs/spend-custom-input/spend-custom-input.component';
import {
  ILineItemExtended,
  IPrimeSpendDistribution,
  ISubitemExtended,
} from '../../../../../../../store/spend/spend.interfaces';
import { spendActionTypes } from '../../../../../../../store/spend/spend.actions';
import { TooltipDirective } from '@app/directives/tooltip.directive';
import { DISTRIBUTION_TYPES } from '@app/framework/constants/spend.constants';

@Component({
  selector: 'app-prime-line-item',
  imports: [
    CdkDragHandle,
    DropdownComponent,
    InputCalendarComponent,
    SpendCustomInputComponent,
    NgClass,
    TooltipDirective,
    FormsModule,
  ],
  templateUrl: './prime-line-item.component.html',
  styleUrl: './prime-line-item.component.scss',
})
export class PrimeLineItemComponent extends BudgetLineItemComponent implements OnInit {
  // who likes code repetition? Not me!

  calcDistribution(item: ILineItemExtended | ISubitemExtended) {
    if (!this.isSubItem) {
      console.warn('calcDistribution called on a line item, but it should be called on a subitem');
      return;
    }
    const distribution: IPrimeSpendDistribution = {
      prime_start_date: dayjs(item.prime_start_date).format(this.DATE_FORMAT),
      prime_duration: item.prime_duration,
      prime_distribution: item.prime_distribution,
      field: 'monthly_prime',
      budget: item.project_total, // should be prime_project_total for prime items
    };
    this.setDisabledMonth(this.item);

    this.store.dispatch(
      spendActionTypes.updatePrimeSubitemDistribution({
        parentId: (item as ISubitemExtended).parent_id,
        lineId: item.id,
        distribution,
      }),
    );
  }

  setDisabledMonth(item: ILineItemExtended) {
    const availableMonths = this.spendDistributionService.getDisabledMonths(
      this.selectedYear,
      item,
      'monthly_prime',
    );

    // disable all months that should be non-editable
    Object.keys(item.monthly_data).forEach((monthKey, index) => {
      item.prime_monthly_disable[monthKey] = !availableMonths[index]; // key starts with 1
    });
  }

  setStartDate(date: string, item: ILineItemExtended) {
    item.prime_start_date = date;
  }

  setItemDuration(duration: number, item: ILineItemExtended) {
    item.prime_duration = duration;
  }

  setItemDistribution(distribution: DISTRIBUTION_TYPES, item: ILineItemExtended) {
    item.prime_distribution = distribution;
  }
}
